import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Success from "../../../components/Toaster/Success";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import GradientButton from "../../../components/Buttons/GradientButton/GradientButton";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import { useDisconnect } from "wagmi";
import { clearUserData} from "../../../redux/slices/userSlice";

const ProfileSection = () => {
  const { disconnect } = useDisconnect();
  const dispatch = useDispatch();
  const { user, email, profileImage, walletAddress } = useSelector(
    (state) => state.user
  );


  const handleLogout = () => {
    disconnect();
    dispatch(clearUserData());
    localStorage.removeItem("profileImage");
    Success({ message: "Logged out successfully" });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress).then(() => {
      Success({ message: "Address copied to clipboard" });
    });
  };



  return (
    <div className="flex items-center justify-center w-full mt-5">
      <div className="w-[90%] sm:w-[85%] md:w-[80%]">
        <div className="w-full border border-regular-orange rounded-[13px] ratingGradient drop-shadow-md p-5 flex flex-col lg:flex-row justify-center items-start gap-10">
          <div className="w-full flex flex-col sm:flex-row items-start md:items-center justify-center gap-6">
            <div className="min-w-fit">
              <img
                src={profileImage || "/assets/upload-image.svg"}
                alt="User Profile"
                className="rounded-full w-32 h-32 object-cover"
              />
            </div>
            <div className="space-y-2 w-11/12">
              <StyledH4Heading fontColor="text-bright-yellow -mb-2">
                {user || "Add your Username"}
              </StyledH4Heading>
              <StyledH6Heading>
                {email || "Add your email address"}
              </StyledH6Heading>
              <StyledSmText fontColor="relative pr-7 flex items-baseline gap-1 w-full sm:w-fit">
                <span className="text-bright-yellow tracking-[0.72px]">
                  Address:
                </span>
                <span className="flex-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {walletAddress}
                </span>
                <button
                  onClick={handleCopy}
                  className="pl-2"
                  aria-label="Copy Address"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 21 24"
                    fill="none"
                  >
                    <path
                      d="M4 18.5V3.5C4 2.11929 5.11929 1 6.5 1H15.305C15.9486 1 16.5673 1.24816 17.0325 1.69282L19.2275 3.79095C19.7209 4.26261 20 4.91553 20 5.59813V18.5C20 19.8807 18.8807 21 17.5 21H6.5C5.11929 21 4 19.8807 4 18.5Z"
                      stroke="#FFD700"
                    />
                    <path
                      d="M0 21.5V6.5C0 5.11929 1.11929 4 2.5 4H11.305C11.9486 4 12.5673 4.24816 13.0325 4.69282L15.2275 6.79095C15.7209 7.26261 16 7.91553 16 8.59813V21.5C16 22.8807 14.8807 24 13.5 24H2.5C1.11929 24 0 22.8807 0 21.5Z"
                      fill="#FFD700"
                    />
                  </svg>
                </button>
              </StyledSmText>
            </div>
          </div>
          <div className="flex justify-between gap-2 lg:flex-col w-full lg:w-fit">
            <Link className="w-full" to="/edit-profile">
              <GradientButton fontColor="w-full !px-5">Edit</GradientButton>
            </Link>
            <GradientButton onClick={handleLogout} fontColor="w-full !px-5">
              Logout
            </GradientButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSection;
